import { atom } from 'jotai';

import { AuthStatuses } from '$src/hooks/auth';

export const authStateAtom = atom<AuthStatuses>(AuthStatuses.PENDING);
